import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { tap } from 'rxjs/operators';

export function add_path_users(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const uuid = componentDataSourceService.getCurrentPathUuid();
  
  if (!uuid) {
    throw new Error('Educational path UUID is required');
  }

  // Extract user IDs from form data
  let userIds: string[] = [];
  
  // Handle different form data structures
  if (data) {
    
    // Handle nested dualPanelSelector structure
    if (data.dualPanelSelector?.dualPanelSelector && Array.isArray(data.dualPanelSelector.dualPanelSelector)) {
      userIds = data.dualPanelSelector.dualPanelSelector;
    }
    // Handle direct dualPanelSelector structure
    else if (data.dualPanelSelector && Array.isArray(data.dualPanelSelector)) {
      userIds = data.dualPanelSelector;
    }
    // Handle users array
    else if (data.users && Array.isArray(data.users)) {
      userIds = data.users;
    }
    // Handle nested users object
    else if (data.users && typeof data.users === 'object') {
      if (data.users.users && Array.isArray(data.users.users)) {
        userIds = data.users.users;
      }
      else {
        Object.values(data.users).forEach(value => {
          if (typeof value === 'string') {
            userIds.push(value);
          }
        });
      }
    }
    // Check if we have any other property that might contain user IDs
    else {
      Object.keys(data).forEach(key => {
        if (key.includes('users') && Array.isArray(data[key])) {
          userIds = data[key];
        }
      });
    }
  }

  if (userIds.length === 0) {
    console.warn('No user IDs found in form data');
  }

  const userData = {
    requirement_started_at: data.requirement_started_at, // Optional
    maintenance_started_at: data.maintenance_started_at, // Optional
    version_id: data.version_id,
    users: userIds
  };

  // First, clear any cached path data to ensure we get fresh data
  componentDataSourceService.clearEducationalPathData();

  // Make the API call
  const request$ = componentDataDestService.http.put(`${environment.apiUrl}/paths/${uuid}/users`, {
    user: userData
  }).pipe(
    tap(response => {
      // Refresh the path data cache to force a reload on next access
      componentDataSourceService.clearEducationalPathData();
    })
  );

  // Use the updateStoreData helper
  componentDataSourceService.updateStoreData(request$, 'educational_path_users').subscribe({
    error: (error) => console.error('Error adding path users:', error)
  });
}